<template>
  <coupon-detail :is-edit='false'>
  </coupon-detail>
</template>

<script>
import CouponDetail from './components/CouponDetail'

export default {
  name: 'CreateCoupon',
  components: {
    CouponDetail
  }
}
</script>

